<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange(page)"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @selection-change="handleSelectionChange"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template slot-scope="scope" slot="menuLeft">
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            plain
            @click.stop="handleAdd()"
          >新增</el-button>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button
            type="primary"
            icon="el-icon-check"
            size="small"
            plain
            @click.stop="handleEdit(scope.row,scope.index)"
          >编辑</el-button>
          <el-button
            type="danger"
            icon="el-icon-check"
            size="small"
            plain
            @click.stop="handleDel(scope.row.id)"
          >删除</el-button>
        </template>
        <template slot-scope="scope" slot="nameForm">
          <el-select
            v-model="bank"
            placeholder="请选择银行"
            filterable="filterable"
            required
            value-key="label"
          >
            <el-option v-for="bank in bankList" :key="bank.value" :label="bank.label" :value="bank"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="openingNameForm">
          <el-input v-model="openingName" placeholder="请输入开户名"></el-input>
        </template>
        <template slot-scope="scope" slot="mobileForm">
          <el-input v-model="mobile" placeholder="请输入银行预留电话"></el-input>
        </template>
        <template slot-scope="scope" slot="numberForm">
          <el-input v-model="number" placeholder="卡号"></el-input>
        </template>
        <template slot-scope="scope" slot="openingBankForm">
          <el-input v-model="openingBank" placeholder="开户行"></el-input>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { bankOption } from "@/const/salesCloud/bankOption";
import {
  findBankCardList,
  addBankCard,
  editBankCard,
  delBankCard
} from "@/api/salesCloud/bank";
import { findByLabel } from "@/util/util";
import { DIC } from "@/const/dic";

export default {
  name: "bank",
  components: {},
  data() {
    return {
      tableOption: bankOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      tabelObj: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      grade: {
        box: false,
        check: []
      },
      bankList: DIC.BANK_LIST,
      bank: {},
      openingName: "",
      mobile: "",
      number: "",
      openingBank: "",
      id: ""
    };
  },
  created() {
    this.handleList();
  },
  watch: {},
  mounted() {},
  computed: {
    ...mapGetters(["permission"])
  },
  props: [],
  methods: {
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      (params.page = this.page.currentPage), (params.size = pageSize);
      findBankCardList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      findBankCardList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      findBankCardList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      findBankCardList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      this.clean();
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      this.clean();
      this.openingName = row.openingName;
      this.mobile = row.mobile;
      this.bank = {
        label: row.name,
        value: row.name
      };
      this.id = row.id;
      this.number = row.number;
      this.openingBank = row.openingBank;
      this.$refs.crud.rowEdit(row, index);
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let parmas = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      findBankCardList(parmas).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      let txt = "";
      let flag = false;
      if (this.openingName == "") {
        txt = "请输入开户名";
        flag = true;
      }
      if (this.mobile == "") {
        txt = "请输入银行预留电话";
        flag = true;
      }
      if (!/^1[3456789]\d{9}$/.test(this.mobile)) {
        txt = "手机号码有误，请重填";
        flag = true;
      }
      if (typeof this.bank.value == "undefined") {
        txt = "请选择银行名称";
        flag = true;
      }
      if (this.number == "") {
        txt = "请输入卡号";
        flag = true;
      }
      if (this.openingBank == "") {
        txt = "请输入开户行";
        flag = true;
      }
      if (flag) {
        this.$message({
          showClose: true,
          message: txt,
          type: "error"
        });
        done();
        this.$refs.crud.rowAdd();
        return;
      }
      let obj = {};
      obj.openingName = this.openingName;
      obj.mobile = this.mobile;
      obj.name = this.bank.value;
      obj.number = this.number;
      obj.openingBank = this.openingBank;
      addBankCard(obj)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success"
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
            done();
            this.$refs.crud.rowAdd();
            return;
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
      done();
    },
    clean() {
      this.openingName = "";
      this.mobile = "";
      this.bank = {};
      this.number = "";
      this.openingBank = "";
      this.id = "";
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange() {
      // console.log(val);
      // this.tableRow = val;
      // this.$notify({
      //     showClose: true,
      //     message: JSON.stringify(val),
      //     type: 'success',
      // });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(id) {
      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }
          delBankCard(id)
            .then(response => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "删除成功",
                  type: "success"
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error"
              });
            });
        })
        .catch(() => {});
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      console.log(row);
      let txt = "";
      let flag = false;
      if (this.openingName == "") {
        txt = "请输入开户名";
        flag = true;
      }
      if (this.mobile == "") {
        txt = "请输入银行预留电话";
        flag = true;
      }
      if (!/^1[3456789]\d{9}$/.test(this.mobile)) {
        txt = "手机号码有误，请重填";
        flag = true;
      }
      if (typeof this.bank.value == "undefined") {
        txt = "请选择银行名称";
        flag = true;
      }
      if (this.number == "") {
        txt = "请输入卡号";
        flag = true;
      }
      if (this.openingBank == "") {
        txt = "请输入开户行";
        flag = true;
      }
      if (flag) {
        this.$message({
          showClose: true,
          message: txt,
          type: "error"
        });
        done();
        this.$refs.crud.rowAdd();
        return;
      }
      let obj = {};
      obj.id = this.id;
      obj.openingName = this.openingName;
      obj.mobile = this.mobile;
      obj.name = this.bank.value;
      obj.number = this.number;
      obj.openingBank = this.openingBank;
      editBankCard(obj)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success"
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
            done();
            this.$refs.crud.rowEdit(obj, index);
            return;
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
      done();
    }
  }
};
</script>

<style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
